module.exports = __webpack_public_path__ + "static/img/Facilitating_the_Discussion_on_LAIs.359ef6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Facilitating_the_Discussion_on_LAIs.png
// module id = QN7F
// module chunks = 1